// LIBRERIE
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Presentation: React.FC = () => {
    const { t } = useTranslation();

    return (
        <section id="presentation" className="space-ptb">
            <div className="container-fluid">
                <div className="box-title">
                    <h2 dangerouslySetInnerHTML={{ __html: t('homePage.presentation.title') as string }} />
                    <p>
                        <span>{t('homePage.presentation.subTitle')}</span>
                    </p>
                    <div className="line"></div>
                </div>
                <div className="row align-items-center justify-content-center">
                    <div className="col-12 col-lg-8 col-xl-8 mb-5 mb-lg-0">
                        <p dangerouslySetInnerHTML={{ __html: t('homePage.presentation.para1') as string }} />
                        <p className="mb-4" dangerouslySetInnerHTML={{ __html: t('homePage.presentation.para2') as string }} />
                        <Link to={'/chi-siamo'} className="btn btn-primary">
                            <span>{t('homePage.presentation.btnText')}</span>
                        </Link>
                    </div>
                    <div className="col-12 col-sm-9 col-md-7 col-lg-4 col-xl-3">
                        <img className="img-fluid" src="/assets/images/inHome/presentation.png" alt={t('homePage.presentation.imgAlt') as string} />
                        <img src="/assets/images/logo.png" alt="logo" />
                    </div>
                </div>
            </div>
        </section>
    )
}
export default Presentation;